import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0c4baa57&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4baa57",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/tmp/ysf/shop-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c4baa57')) {
      api.createRecord('0c4baa57', component.options)
    } else {
      api.reload('0c4baa57', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0c4baa57&scoped=true", function () {
      api.rerender('0c4baa57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/articleList/index.vue"
export default component.exports